// extracted by mini-css-extract-plugin
export default {"element":"StartCreation_element__ePUYW","iconWrapper":"StartCreation_iconWrapper__ubJl+"};